import { render } from "./PendingApplication.vue?vue&type=template&id=5437ff7e&scoped=true"
import script from "./PendingApplication.vue?vue&type=script&lang=js"
export * from "./PendingApplication.vue?vue&type=script&lang=js"

import "./PendingApplication.vue?vue&type=style&index=0&id=5437ff7e&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5437ff7e"]])

export default __exports__